module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/lipBalm@2x_a3839a.png";